import { useRouter } from 'next/router'
import { useCallback } from 'react'

function useQueryStringController() {
  const router = useRouter()

  const replace = useCallback(
    (query: any) => {
      const baseUrl = `${window.location.origin}${window.location.pathname}`
      router.replace({
        pathname: baseUrl,
        query,
      })
    },
    [router],
  )

  const updateQuery = useCallback(
    (updateValue: any, removeName?: any) => {
      const { query } = router
      const currentQuery = { ...query }
      if (removeName) {
        if (typeof removeName === 'object') {
          removeName.forEach((key: any) => delete currentQuery[key])
        }
        else {
          delete currentQuery[removeName]
        }
      }

      const newQuery = {
        ...currentQuery,
        ...updateValue,
      }
      replace(newQuery)
    },
    [router, replace],
  )

  const removeQuery = useCallback(
    (name: string | string[]) => {
      const removeKeys = new Set(Array.isArray(name) ? name : [name])

      const newQuery = Object.fromEntries(
        Object.entries(router.query).filter(([key]) => !removeKeys.has(key)),
      )

      replace(newQuery)
    },
    [router, replace],
  )

  return {
    updateQuery,
    removeQuery,
  }
}

export default useQueryStringController
